<!-- <div class="splash" #splash>
  <div *ngIf="!this.pauseGif">
    <img class="splash-gif" alt="Splash Image" (load)="this.loadImgComplete($event)" [src]="imgString" #img>
  </div>
  <div *ngIf="this.pauseGif">
    <img alt="Splash Image" style="width: 85%; max-width: 551px;" src="assets/logo/logo-pedeaqui-white.png">
  </div>
</div> -->

<div class="splash" #splash >
  
  <div class="image-card" [ngClass]="{'not-animation': this.imgLoaded}">
    <img alt="Splash Image" (load)="this.loadImgComplete($event)" [src]="imgString" #img>
  </div>

  <!--Loading-->
  <div class="box-loader" *ngIf="this.company && this.imgLoaded">
    <div class="loader">
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="circle"></div>
    </div>
    <span style="text-align: center; font-weight: 600; color: var(--primary-color);">Carregando...</span>
    <!-- <span style="text-align: center; font-weight: 600;">Bem-vindo ao {{ this.company.company.companyName }}!</span> -->
  </div>

  <div class="box-preload" *ngIf="!this.imgLoaded">
    <div class="preload" style="width: 69px; height: 15px;"></div>
    <div class="preload" style="width: 108px; height: 24px;"></div>
  </div>

  <div class="WariningPowered">
    <div style="position: relative;top: 13px;">
      <span style=" color: #652969; font-size: 13px;">from</span>
    </div>
    <div>
      <img src="assets/logo/logo-qrcode-pedeaqui.png" style="width: 32px;"/><img src="assets/logo/logo-name-pedeaqui.png" style="width: 100px;"/>
    </div>
    <div style="text-align: center; margin-top: -5px;">
       <span style="color: #652969; font-size: 13px; font-weight: 500;">v{{ version }}</span>
    </div>
  </div>
</div>
